import React from 'react'
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

export const NoData = (props, context) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td>
                        <Alert className="mb-0 info">
                            <i className="fa fa-info mx-2"></i> {context.t("There is no data to show")}
                        </Alert>
                        <br/>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

NoData.contextTypes = {
    t: PropTypes.func
}